import moment from 'moment'
import {videoTypes} from 'constants/dances'

const emptyVideos = () =>
    Object.fromEntries(
        videoTypes.map((type) => [
            type,
            {videoUrl: '', youtubeId: '', youtubeStatus: ''},
        ])
    )

export const getEmptyDanceValues = () => ({
    hidden: false,
    nameEng: '',
    nameHeb: '',
    songName: '',
    yearCreated: moment().format('YYYY'),
    filmedDate: '',
    choreographers: [],
    performers: [],
    composers: [],
    lyricists: [],
    companies: [],
    shapes: [],
    youtubeIds: [],
    facebookVideosIds: [],
    lyrics: '',
    lyricsEng: '',
    danceSteps: '',
    danceStepsEng: '',
    danceStory: '',
    danceStoryEng: '',
    videos: emptyVideos(),
})

export const defaultValues = {dance: getEmptyDanceValues()}

export const errors = {
    duplicateKey: 'document already exists with duplicate key and value',
}
